<template>
  <div class="doctor">
    <div class="first itemWrapper">
      <img src="@/assets/img/center/1.png" alt />
    </div>
    <div class="second itemWrapper">
      <img src="@/assets/img/center/2.png" alt />
    </div>
    <div class="third itemWrapper">
      <img src="@/assets/img/center/3.png" alt />
    </div>
    <div class="fourth itemWrapper">
      <img src="@/assets/img/center/4.png" alt />
    </div>
  </div>
</template>

<script>
export default {
  name: 'Center'
}
</script>

<style lang='stylus' scoped>
@import '~@/assets/styles/varibles.styl'

.doctor
  .itemWrapper
    width 100%
    display flex
    flex-direction row
    justify-content center
    align-items center

    img
      width 1280px

  .first
    background #050206
    height 594px

  .second
    background #F8F8F8
    height 1000px

  .third
    background #E9E4DC
    height 1000px

  .fourth
    background #F8F8F8
    height 1000px
</style>



// WEBPACK FOOTER //
// src/views/YxzCenter/YxzCenter.vue